<template>
    <div class="open-positions-wrapper">
        <div class="positions-list" v-if="!this.isFetching">
            <div v-for="position of listOfFirstPositions" :key="position.id">
                <a :href="`/career/detail?position=${position.id}&title=${position.title}`" class="position-wrapper">
                    <strong class="new-text-xl">{{ position.title }}</strong>
                    <div class="position-info"> 
                        <div>
                            <figure>
                                <span class="material-symbols-rounded">location_on</span>
                            </figure>
                            <p class="new-text-md text-color-default" v-html="countryOfPosition(position.regionIdCountry, position.region)"></p>
                        </div>
                        <div>
                            <figure>
                                <span class="material-symbols-rounded">schedule</span>
                            </figure>
                            <p class="new-text-md text-color-default" v-html="typeOfJob(position.parttime, position.fulltime, position.contractor)"></p>
                        </div>
                    </div>

                    <figure class="position-link-desktop">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.50062 10.5L12.8904 10.5L7.9383 15.431C7.65572 15.7132 7.49698 16.096 7.49698 16.4951C7.49698 16.8942 7.65572 17.277 7.9383 17.5592C8.22087 17.8414 8.60412 18 9.00374 18C9.40336 18 9.78661 17.8414 10.0692 17.5592L17.5723 10.0654C17.7089 9.92286 17.816 9.75479 17.8874 9.57081C18.0375 9.20592 18.0375 8.79664 17.8874 8.43175C17.816 8.24777 17.7089 8.07969 17.5723 7.93716L10.0692 0.443336C9.92968 0.302858 9.76371 0.191356 9.58085 0.115266C9.39798 0.0391762 9.20184 1.13819e-06 9.00374 1.12087e-06C8.80564 1.10355e-06 8.6095 0.0391761 8.42664 0.115266C8.24377 0.191356 8.0778 0.302857 7.9383 0.443336C7.79765 0.582664 7.68601 0.748427 7.60982 0.931066C7.53364 1.1137 7.49442 1.3096 7.49442 1.50746C7.49442 1.70531 7.53364 1.90121 7.60982 2.08385C7.68601 2.26648 7.79765 2.43225 7.9383 2.57158L12.8904 7.50251L1.50062 7.50251C1.10263 7.50251 0.720941 7.66042 0.439519 7.94149C0.158097 8.22257 -1.08591e-06 8.60378 -1.12066e-06 9.00128C-1.15541e-06 9.39878 0.158097 9.77999 0.439519 10.0611C0.72094 10.3421 1.10263 10.5 1.50062 10.5Z" fill="#5937B7"/>
                        </svg>
                    </figure>
                </a>
            </div>
            <v-button
                v-if="this.showButton"
                variant="secondary"
                label="Show all open positions"
                position="center"
                @onClick="showAll()"
                >
            </v-button>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isFetching: true,
            listOfPositions: [],
            listOfFirstPositions: [],
            mobile: true,
            showButton: true,
            numberOfPositionsForMobile: 5,
            numberOfPositionsForDesktop: 10,
            regions:{
                de: ['Germany', 'Deutschland'],
                cz: ['Czech Republic', 'Czech Republic'],
                sk: ['Slovakia', 'Slovakia'],
                it: ['Italy', 'Italia']
            }
        }
    },

    created(){
        this.screenType()
    },

    mounted() {
        const instance = axios.create()

        instance.get('/api/datacruit?url=advertising/jobAds?sorting=1')
        .then((res) => {
            this.listOfPositions = res.data
            this.firstItems()
            this.showMore()
            this.isFetching = false
        })
        .catch((e) => {
            console.log(e)
            this.isFetching = false
        })
    },

    methods: {
        typeOfJob(parttime, fulltime, contractor){
            const typeOfJobArr = []

            if (parttime) {
                typeOfJobArr.push('Part-time job')
            }

            if (fulltime) {
                typeOfJobArr.push('Full-time job')
            }

            if (contractor) {
                typeOfJobArr.push('Contractor')
            }

            const spaceArr = typeOfJobArr.join(', ')
            
            return  spaceArr.toString()
        },

        screenType(){
            if(window.innerWidth > 991){
                this.mobile = false
            }   
        },

        firstItems(){
            if (this.mobile) {                
                this.listOfFirstPositions = this.listOfPositions.slice(0, this.numberOfPositionsForMobile)
            } else {
                this.listOfFirstPositions = this.listOfPositions.slice(0, this.numberOfPositionsForDesktop)
            }
        },

        countryOfPosition(regionId, regionCity){
            if (regionCity === this.regions[regionId][0] || regionCity === this.regions[regionId][1]) {
                return this.regions[regionId][0]
            }

            return `${this.regions[regionId][0]} - ${regionCity}`
        },

        showMore(){
            if (this.mobile && (this.listOfPositions.length <= this.numberOfPositionsForMobile)) {
                this.showButton = false

                return
            }

            if (!this.mobile && (this.listOfPositions.length <= this.numberOfPositionsForDesktop)) {
                this.showButton = false

                return
            }

            this.showButton = true
            return
        },

        showAll(){
            this.showButton = false
            this.listOfFirstPositions = this.listOfPositions
        }
    }
}

</script>

